module.exports = __webpack_public_path__ + "static/img/ssssss1.2d7f3a3f.png";